var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyperlinkMyPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3593_196187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4524 6.6524C15.7531 6.65168 14.376 5.27452 14.3755 3.57548V0H4.86153C3.84327 0.00288462 3.01827 0.827885 3.01538 1.84615V22.1538C3.01827 23.1721 3.84327 23.9971 4.86153 24H19.1815C20.2 23.9971 21.0248 23.1721 21.0276 22.1538V6.6524H17.4524ZM6.34471 9.41538H12.9969C13.3368 9.41538 13.6123 9.69087 13.6123 10.0308C13.6123 10.3707 13.3368 10.6462 12.9969 10.6462H6.34471C6.0048 10.6462 5.72932 10.3707 5.72932 10.0308C5.72932 9.69087 6.0048 9.41538 6.34471 9.41538ZM18.3199 19.957H6.34471C6.0048 19.957 5.72932 19.6815 5.72932 19.3416C5.72932 19.0017 6.0048 18.7262 6.34471 18.7262H18.3199C18.6599 18.7262 18.9353 19.0017 18.9353 19.3416C18.9353 19.6815 18.6599 19.957 18.3199 19.957ZM18.3199 15.2986H6.34471C6.0048 15.2986 5.72932 15.0228 5.72932 14.6832C5.72932 14.3433 6.0048 14.0678 6.34471 14.0678H18.3199C18.6599 14.0678 18.9353 14.3433 18.9353 14.6832C18.9353 15.0228 18.6599 15.2986 18.3199 15.2986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4524 5.42201H20.1723L15.6062 0.868164V3.57586C15.6069 4.59509 16.4329 5.42105 17.4524 5.42201Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3593_196187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlinkMyPage);
export default __webpack_public_path__ + "static/media/hyperlink-my-page.1e4a0d3d05bbfcf56d12c72832de24ac.svg";
export { ForwardRef as ReactComponent };